import './style/index.less'
import InputWalletDropdown from './InputWalletDropdown'

export default InputWalletDropdown